import { render, staticRenderFns } from "./KnCancellationModal.vue?vue&type=template&id=2525762a&"
import script from "./KnCancellationModal.vue?vue&type=script&lang=js&"
export * from "./KnCancellationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports